import { isNamedTimezone } from '@shared/lib/date-time';

export type LocationTimezone = string | null | undefined;

export const toLocationZone = (timezone: unknown): string => {
  if (!isNamedTimezone(timezone)) throw new RangeError('Часовой пояс локации не загружен. Обновите данные.');
  return timezone;
};
